/* eslint-disable @typescript-eslint/no-unused-vars */
import type { AppState } from "ee/reducers";

export interface DependentFeatureFlags {}

export const getFeatureFlagsForEngine = (state: AppState) => {
  return {};
};
